/*! *********************************************************************
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */
/**
 * Get preferred languages from Adobe IMS
 */
var IMSLanguageDetector = /** @class */ (function () {
    function IMSLanguageDetector() {
    }
    IMSLanguageDetector.prototype.detect = function () {
        var found = [];
        var adobeIMS = window.adobeIMS;
        if (adobeIMS &&
            typeof adobeIMS.isSignedUser === 'function' &&
            adobeIMS.isSignedUser())
            found = adobeIMS.getUserProfile().preferred_languages;
        return found;
    };
    return IMSLanguageDetector;
}());
export default IMSLanguageDetector;
